<template>
  <div
    class="relative min-h-[570px] md:min-h-screen overflow-hidden flex items-center justify-center lg:px-14 tw-pt-[10rem] bg-accent"
  >
    <video
      src="@/assets/vedios/home.mp4"
      loop=""
      autoplay=""
      defaultmuted=""
      preload="auto"
      playsinline=""
      muted
      class="hero-image"
    ></video>
    <div
      data-v-9611db31=""
      class="max-w-[1440px] text-center font-Approach xl:px-[86px] px-4 pt-[9.5rem] mx-auto"
    >
      <div class="hero-text-container mb-[4rem] flex items-center flex-col">
        <h2
          style="line-height: 1.3"
          class="title uppercase xl:text-[4.5rem] lg:text-[4.5rem] md:text-[3.5rem] sm:text-[2.5rem] text-[#fff000]"
        >
          One Platform for Infinite Client Possibilities
        </h2>
        <p
          class="subtitle text-center mt-5 font-light lg:text-[36px] md:text-[26px] sm:text-[18px]"
        >
          Lorem ipsum dolor sit amet, <br />
          consectetur adipiscing elit. In turpis <br />
          ornare ut facilisis massa.
        </p>
        <button
          class="round-btn relative h-[60px] outline-none mt-10 flex items-center rounded-ee-2xl gap-2 px-10 py-2 text-[16px] text-black font-semibold px-5 bg-[#FFF000]"
        >
          Get Started
          <img src="@/assets/images/Arrow 4black.svg" />
        </button>
      </div>
    </div>
  </div>
  <!-- <div class="h-[1000px] relative top-0">
    <video
      webkit-playsinline="true"
      playsinline="true"
      autoplay=""
      muted="muted"
      ref="vid"
      class="absolute top-0 w-full h-full"
      loop
    >
      <source src="@/assets/vedios/home.mp4" type="video/mp4" />
    </video>
    <div class="shadow-overlay flex items-center justify-center flex-col">
      <h1 class="banner-title">
        ALL YOUR CLIENTS <br />
        IN ONE PLACE.
      </h1>
      <h3 class="font-light text-[36px] text-center">
        Lorem ipsum dolor sit amet, <br />
        consectetur adipiscing elit. In turpis <br />
        ornare ut facilisis massa.
      </h3>
      <button
        class="round-btn relative h-[60px] outline-none mt-10 flex items-center rounded-ee-2xl gap-2 px-10 py-2 text-[16px] text-black font-semibold px-5 bg-[#FFF000]"
      >
        Get Started
        <img src="@/assets/images/Arrow 4black.svg" />
      </button>
    </div>
  </div> -->
</template>
<script>
// import { onMounted, ref } from "vue";

export default {
  name: "fixed-vedio",
  setup() {
    // const vid = ref(null);
    // const playvedio = () => {
    //   vid.value.play();
    // };
    // onMounted(() => {
    //   playvedio();
    // });
    // return { vid, playvedio };
  },
};
</script>
<style scoped>
.hero-image {
  height: 100%;
  left: 0;
  -o-object-fit: cover;
  object-fit: cover;
  overflow: clip;
  overflow-clip-margin: content-box;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
  /* transform: translate(var(--tw-translate-x), var(--tw-translate-y))
    rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y))
    scaleX(1.1) scaleY(1.1); */
  transform: translate(var(--tw-translate-x), var(--tw-translate-y))
    rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y))
    scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));

  filter: brightness(0.3) var(--tw-drop-shadow);
  width: 100%;
}
.hero-text-container {
  color: var(--third);
  height: 100%;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  position: relative;
  width: 100%;
  z-index: 10;
}
</style>
